import React from 'react'
import { Dialog } from 'react-aria-components'
import { BsX } from 'react-icons/bs'

import { Modal } from '../ui/modal/Modal'
import { FullScreenModalBackdrop } from '../ui/modal/ModalOverlay'
import WalletAmountSelector from './WalletAmountSelector'

interface AddFundsModalProps {
  isOpen: boolean
  onClose: () => void
  successUrl?: string
  cancelUrl?: string
  message?: string
}

const AddFundsModal: React.FC<AddFundsModalProps> = ({ isOpen, onClose, successUrl, cancelUrl, message }) => {
  return (
    <FullScreenModalBackdrop isOpen={isOpen} onOpenChange={(open) => !open && onClose()} className='tw-items-center'>
      <Modal className='tw-w-full tw-max-w-lg'>
        <Dialog
          aria-label='Add funds to wallet'
          className='outline-none tw-relative tw-flex tw-max-h-[90vh] tw-w-full tw-max-w-lg tw-flex-col tw-overflow-hidden tw-rounded-2xl tw-bg-white tw-shadow-2xl'
        >
          {() => (
            <>
              {/* Header */}
              <div className='tw-flex tw-items-center tw-justify-between tw-border-b tw-border-gray-100 tw-px-6 tw-py-4'>
                <h2 className='tw-text-xl tw-font-bold tw-text-gray-900'>Add Funds to Wallet</h2>
                <button
                  type='button'
                  aria-label='Close'
                  onClick={onClose}
                  className='tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-gray-200 tw-bg-white tw-text-gray-500 tw-transition hover:tw-bg-gray-100 hover:tw-text-gray-700'
                >
                  <BsX size={20} />
                </button>
              </div>

              {/* Content */}
              <div className='tw-flex-1 tw-overflow-y-auto tw-p-6'>
                {message && (
                  <div className='tw-mb-6 tw-rounded-lg tw-border tw-border-amber-200 tw-bg-amber-50 tw-p-4'>
                    <div className='tw-flex tw-gap-3'>
                      <div className='tw-flex-shrink-0'>
                        <svg className='tw-h-5 tw-w-5 tw-text-amber-500' viewBox='0 0 20 20' fill='currentColor'>
                          <path
                            fillRule='evenodd'
                            d='M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z'
                            clipRule='evenodd'
                          />
                        </svg>
                      </div>
                      <p className='tw-text-sm tw-text-amber-800'>{message}</p>
                    </div>
                  </div>
                )}

                <WalletAmountSelector successUrl={successUrl} cancelUrl={cancelUrl} />
              </div>
            </>
          )}
        </Dialog>
      </Modal>
    </FullScreenModalBackdrop>
  )
}

export default AddFundsModal
